import React, { useRef } from "react";
import DataTable from "datatables.net-react";
import DT from "datatables.net-dt";
import { dateTimeFormatter } from "utils/utils";

DataTable.use(DT);

const MessagesTable = ({ messages = [], onUpdated = () => { } }) => {
  const tableRef = useRef(null);

  const tableData = messages.map((message) => {
    return [
      message.id,
      message.public_id,
      dateTimeFormatter.format(new Date(message.created_at)),
      `<div>${message.name ?? "No Name"}</div><div style="word-break: none">${message.email ?? "Unknown Email"
      }</div>`,
      message.caller ?? "Unknown Caller",
      `${message.caller_city ?? "Unknown City"}, ${message.caller_state ?? "Unknown State"
      }`,

      message.topic ?? "N/A",
      `<div style="max-height:200px; overflow:auto;">${message.short_summary ?? "N/A"
      }</div>`,
      `<div style="max-height:200px; overflow:auto;">${message.aw_transcript ?? message.transcript ?? "N/A"
      }</div>`,
      `<audio controls>
  <source src="${message.aw_recording_url}" type="audio/mpeg">
      </audio>`,
    ];
  });

  return (
    <div>
      <div style={{ fontSize: "32px", fontWeight: "bold" }}>
        Messages ({messages.length})
      </div>
      <DataTable
        ref={tableRef}
        data={tableData}
        className="display"
        options={{
          responsive: true,
          select: true,
          pageLength: 25,
          order: [[0, "desc"]],
        }}
      >
        <thead>
          <tr>
            <th style={{ width: "80px" }}>ID</th>
            <th>Public ID</th>
            <th>Called At</th>
            <th>Name</th>
            <th>Number</th>
            <th>Location</th>
            <th style={{ minWidth: "150px" }}>Topic</th>
            <th style={{ minWidth: "350px" }}>Summary</th>
            <th style={{ minWidth: "350px" }}>Text</th>
            <th></th>
          </tr>
        </thead>
      </DataTable>
    </div>
  );
};

export default MessagesTable;
